import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { itemPath, certificationItems, resumeItem, sectionsPath } from '../../../utility/coachCertification'
import ProgressBar from './ProgressBar'

import classes from './PriceCard.module.scss'
import buttonClasses from './Button.module.scss'

const PriceCardProgress = ({ certification }) => {
  const { t } = useTranslation()
  const resume = resumeItem(certificationItems(certification))

  return (
    <div>
      <div className={classNames('d-flex align-items-center', classes.stateRow)}>
        <i className={classNames('fa fa-check-circle', classes.purchasedIcon)} aria-hidden='true' />
        <span className={classes.stateTitle}>{t('portal.certification.priceCard.inProgress')}</span>
      </div>
      <ProgressBar
        done={certification.completedCount}
        total={certification.totalCount}
        label={t('portal.certification.priceCard.progress', { done: certification.completedCount, total: certification.totalCount })}
        thick
        className='mb-3'
      />
      <Link
        to={resume ? itemPath(resume) : sectionsPath(certification.id)}
        className={classNames('btn btn-primary text-white d-flex justify-content-center mb-3', buttonClasses.primary)}
      >
        {t('portal.certification.priceCard.resume')}
      </Link>
    </div>
  )
}

PriceCardProgress.propTypes = {
  certification: PropTypes.shape({
    id: PropTypes.number.isRequired,
    completedCount: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    sections: PropTypes.array.isRequired,
  }).isRequired,
}

export default PriceCardProgress
